import { Button } from '@warp-ds/react/components/button';
import { useState } from 'react';
import type { LmsLocationFacet } from '@/interfaces/lms';
import { NestedCheckboxFilter } from './NestedCheckboxFilter';

interface Props {
    continent: LmsLocationFacet;
    checked: string[];
    onChange: (value: string[]) => void;
}

export const CollapsibleContinent = ({ continent, checked, onChange }: Props) => {
    const [expanded, setExpanded] = useState(false);

    const nestedFacets: LmsLocationFacet[] = continent.children
        .sort((a, b) => b.count - a.count)
        .slice(0, expanded ? continent.children.length : 3);

    return (
        <div className="space-y-8">
            <h4 className="t5">{continent.text}</h4>
            {nestedFacets.map((facet) => (
                <NestedCheckboxFilter
                    key={facet.name.replace(' ', '_')}
                    facet={facet}
                    ancestors={[]}
                    checked={checked}
                    onChange={onChange}
                />
            ))}
            {continent.children.length > 3 && (
                <Button
                    link
                    data-testid={`destination-${continent.name.replace(' ', '_')}-button`}
                    onClick={() => setExpanded(!expanded)}
                    className="!mt-8">
                    {expanded ? '- Vis færre' : '+ Vis alle'}
                </Button>
            )}
        </div>
    );
};
